export default __webpack_public_path__ + "static/media/17.21873872.png";